export default "__VITE_PUBLIC_ASSET__f74ac9bf__"